import { KotlinLoggingConfiguration_getInstance2pq6qv2bwynbv as KotlinLoggingConfiguration_getInstance } from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/KotlinLoggingConfiguration.mjs';
import {
  Level_INFO_getInstance24xg9wydggzl5 as Level_INFO_getInstance,
  Level_DEBUG_getInstance2qkta2bzcdm6b as Level_DEBUG_getInstance,
} from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/Level.mjs';
import { JsonFormatter_instancevx3bw778eawd as JsonFormatter_instance } from './JsonFormatter.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function initializeLogging(developmentMode) {
  var tmp = KotlinLoggingConfiguration_getInstance();
  var tmp_0;
  if (developmentMode) {
    tmp_0 = Level_DEBUG_getInstance();
  } else {
    tmp_0 = Level_INFO_getInstance();
  }
  tmp.i2g_1 = tmp_0;
  KotlinLoggingConfiguration_getInstance().j2g_1 = JsonFormatter_instance;
}
//region block: exports
export {
  initializeLogging as initializeLogging2wy35dn799fjs,
};
//endregion

//# sourceMappingURL=InitializeLogging.mjs.map
